let DashBoard = () => import('../pages/mypage/Dashboard');
let OrderList = () => import('../pages/mypage/order/OrderList');
let OrderDetails = () => import('../pages/mypage/order/OrderDetails');
let OrderExpand = () => import('../pages/mypage/order/OrderExpand');
let PaymentList = () => import('../pages/mypage/order/PaymentList');
let QnaList = () => import('../pages/mypage/qna/QnaList.vue');
let QnaView = () => import('../pages/mypage/qna/QnaView.vue');
let QnaForm = () => import('../pages/mypage/qna/QnaForm.vue');
let ContactUsList = () => import('../pages/mypage/contactus/ContactUsList.vue');
let ContactUsView = () => import('../pages/mypage/contactus/ContactUsView.vue');
let ContactUsForm = () => import('../pages/mypage/contactus/ContactUsForm.vue');
let RefundRequests = () => import('../pages/mypage/refund_request/RefundRequestList');
let RefundRequestCreate = () => import('../pages/mypage/refund_request/RefundRequestCreate');
let Wishlist = () => import('../pages/mypage/Wishlist');
let Conversations = () => import('../pages/mypage/Conversations');
let ConversationDetails = () => import('../pages/mypage/ConversationDetails');
let FollowedShops = () => import('../pages/mypage/FollowedShops');
let Wallet = () => import('../pages/mypage/Wallet');
let Coupon = () => import('../pages/mypage/Coupon');
let Profile = () => import('../pages/mypage/Profile');
let Address = () => import('../pages/mypage/Address');
let Withdrawal = () => import('../pages/mypage/Withdrawal');
let RefundInfo = () => import('../pages/mypage/RefundInfo');
let MypageLayout = () => import('../components/mypage/MypageLayout');
let Error404 = () => import('../pages/errors/404');
let UnpaidConfirmed = () => import('../pages/mypage/UnpaidConfirmed');

export default [
    {
        path: '/mypage/',
        component: MypageLayout,
        redirect: '/mypage/dashboard',
        children: [
            {
                path: 'dashboard',
                component: DashBoard,
                name: 'DashBoard',
                meta: { requiresAuth: true },
            },
            {
                path: 'order-list',
                component: OrderList,
                name: 'OrderList',
                meta: { requiresAuth: true },
            },
            {
                path: 'order-expand',
                component: OrderExpand,
                name: 'OrderExpand',
                meta: { requiresAuth: true },
            },
            {
                path: 'order-details/:code',
                component: OrderDetails,
                name: 'OrderDetails',
                meta: { requiresAuth: true },
            },
            {
                path: 'payment-list',
                component: PaymentList,
                name: 'PaymentList',
                meta: { requiresAuth: true },
            },
            {
                path: 'qna-list',
                component: QnaList,
                name: 'QnaList',
                meta: { requiresAuth: true },
            },
            {
                path: 'qna-view/:id',
                component: QnaView,
                name: 'QnaView',
                meta: { requiresAuth: true },
            },
            {
                path: 'qna-form',
                component: QnaForm,
                name: 'QnaForm',
                meta: { requiresAuth: true },
            },
            {
                path: 'contactus-list',
                component: ContactUsList,
                name: 'ContactUsList',
                meta: { requiresAuth: true },
            },
            {
                path: 'contactus-view/:id',
                component: ContactUsView,
                name: 'ContactUsView',
                meta: { requiresAuth: true },
            },
            {
                path: 'contactus-form',
                component: ContactUsForm,
                name: 'ContactUsForm',
                meta: { requiresAuth: true },
            },
            {
                path: 'refund-info',
                component: RefundInfo,
                name: 'RefundInfo',
                meta: { requiresAuth: true },
            },
            {
                path: 'refund-requests',
                component: RefundRequests,
                name: 'RefundRequests',
                meta: { requiresAuth: true },
            },
            {
                path: 'create-refund-request/:orderId',
                component: RefundRequestCreate,
                name: 'CreateRefundRequest',
                meta: { requiresAuth: true },
            },
            {
                path: 'wishlist',
                component: Wishlist,
                name: 'Wishlist',
                meta: { requiresAuth: true },
            },
            {
                path: 'followed-shops',
                component: FollowedShops,
                name: 'FollowedShops',
                meta: { requiresAuth: true },
            },

            {
                path: 'product-query',
                component: window.shopSetting.general_settings.conversation_system == 1 ? Conversations : Error404,
                name: 'Conversations',
                meta: { requiresAuth: true },
            },
            {
                path: 'product-query/:slug',
                component: window.shopSetting.general_settings.conversation_system == 1 ? ConversationDetails : Error404,
                name: 'ConversationsDetails',
                meta: { requiresAuth: true },
            },
            {
                path: 'wallet',
                component: window.shopSetting.general_settings.wallet_system == 1 ? Wallet : Error404,
                name: 'Wallet',
                meta: { requiresAuth: true },
            },
            {
                path: 'coupon',
                component: Coupon,
                name: 'Coupon',
                meta: { requiresAuth: true },
            },
            {
                path: 'point',
                component: () => import('../pages/mypage/Point.vue'),
                name: 'Point',
                meta: { requiresAuth: true },
            },
            {
                path: 'profile',
                component: Profile,
                name: 'Profile',
                meta: { requiresAuth: true },
            },
            {
                path: 'withdrawal',
                component: Withdrawal,
                name: 'Withdrawal',
                meta: { requiresAuth: true },
            },
            {
                path: 'address',
                component: Address,
                name: 'Address',
                meta: { requiresAuth: true },
            },
            {
                path: 'unpaid-confirmed',
                component: UnpaidConfirmed,
                name: 'UnpaidConfirmed',
                meta: { requiresAuth: true },
            },
        ],
    },
];
